
      // Check if Google Auth is enabled before loading the script
      if (import.meta.env?.VITE_ENABLE_GOOGLE_AUTH !== 'false') {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    